import React from "react";
import { useTranslation } from "react-i18next";
import { EditOutlined, DeleteOutlined, EyeOutlined } from "us.icons";
import { $Popconfirm } from "us.common/components";
import { AdditionalInfoAction } from "../../Constants";

interface ItemMenuProps {
  isEditable?: boolean;
  actions?: AdditionalInfoAction[];
  onCallAction: (actionType: AdditionalInfoAction) => void;
}

/**
 * @description - Item types table action menu.
 * @link Design Document - https://unicorn-solutions.atlassian.net/browse/UBX4-23262
 * @author Ishan Udyoga <ishanud@unicorn-solutions.com>
 * @since 04/11/2024
 */
const ItemMenu: React.FC<ItemMenuProps> = ({
  isEditable,
  actions = [AdditionalInfoAction.EDIT, AdditionalInfoAction.DELETE],
  onCallAction,
}) => {
  const { t } = useTranslation();

  return (
    <div className="table-more-content" data-testid="popover-content">
      {actions.includes(AdditionalInfoAction.EDIT) && (
        <div
          className="d-flex  flex-row more-item"
          data-testid="edit-btn"
          onClick={() => onCallAction(AdditionalInfoAction.EDIT)}
        >
          <div className="p-1">
            {!isEditable && <EyeOutlined />}
            {isEditable && <EditOutlined />}
          </div>
          <div className="p-1">
            {isEditable
              ? t("US.COLLECTION.COMMON:COMMON.EDIT")
              : t("US.COLLECTION.COMMON:COMMON.VIEW")}
          </div>
        </div>
      )}

      {actions.includes(AdditionalInfoAction.DELETE) && (
        <$Popconfirm
          title={t("US.COLLECTION.COMMON:COMMON.SURE_TO_DELETE_?")}
          data-testid="popUpConfirm-box"
          onConfirm={() => onCallAction(AdditionalInfoAction.DELETE)}
        >
          <div
            className="d-flex mb-2 flex-row more-item text-error"
            data-testid="delete-btn"
          >
            <div className="p-1">
              <DeleteOutlined />
            </div>
            <div className="p-1">{t("US.COLLECTION.COMMON:COMMON.DELETE")}</div>
          </div>
        </$Popconfirm>
      )}
    </div>
  );
};

export default ItemMenu;
